import { Box } from '@factorialco/deprecated-design-system'
import { Widget } from '@factorialco/f0-react/dist/experimental'
import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'
import { isEmpty } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { CustomTwoColumnsList } from 'modules/expenses/components/expenses/Detail/_Form/Common/ConfirmationScreen/CustomTwoColumnList'
import CustomWidgetHeaderButton from 'modules/expenses/components/expenses/Detail/_Form/Common/ConfirmationScreen/widgets/CustomWidgetHeaderButton'
import { Expensable } from 'modules/expenses/types/Expensable'

import { buildMileageData } from './helpers/buildMileageData'
import { buildPerDiemData } from './helpers/buildPerDiemData'

interface TripInformationWidgetProps {
  expensable: Expensable
  editable: boolean
  onEdit: () => void
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
}

const buildWidgetData = (
  expensable: Expensable,
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
) => {
  if (resourceType === 'mileage') {
    return buildMileageData(expensable)
  }
  if (resourceType === 'perdiem') {
    return buildPerDiemData(expensable)
  }
  // Expense doesn't have trip information, so return empty array
  return []
}

const TripInformationWidget = ({
  expensable,
  editable,
  onEdit,
  resourceType,
}: TripInformationWidgetProps) => {
  const list = buildWidgetData(expensable, resourceType)

  if (isEmpty(list)) {
    return null
  }

  return (
    <Box gap="s16" position="relative">
      <Widget
        header={{
          title: i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.title'),
        }}
      >
        <CustomTwoColumnsList list={list} />
      </Widget>
      {editable && (
        <CustomWidgetHeaderButton
          label={i18n.t('expenses_v2.confirmation_screen.confirmation_screen_block_edit_action')}
          onClick={onEdit}
        />
      )}
    </Box>
  )
}

export default TripInformationWidget
